import { render, staticRenderFns } from "./ModalObservation.vue?vue&type=template&id=08dfaf7b&"
import script from "./ModalObservation.vue?vue&type=script&lang=js&"
export * from "./ModalObservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports